export const NAME = 'NewCdbLog';
export const CRUMB_LABEL_KEY = 'NewCdbLog';
export { DMS_MODULE } from '../constants';
